export default __webpack_public_path__ + "static/media/uploadPhoto.8760a3e0.svg";